import * as React from 'react';
import { getAttachementUploadUrl } from 'containers/OutWorkbench/utils';
import SmMaking, { MakingProps } from 'containers/SmWorkbench/ProjectDetail/Show/Detail/Bottom/Making';
import { QuotationsType } from 'containers/OutWorkbench/utils';
import PropTypes from 'prop-types';
import { XiaoHao } from './XiaoHao';
import { hasGrayConfigWithoutGroup } from 'utils/gray';
import _ from 'lodash';
import { Alert, Typography } from '@bedrock/components';
import { AlertTriangle, AlertTriangleFilled, SignetFilled } from '@bedrock/icons-react';
import TextAreaShow from '@mpc/common/src/components/SForm/SFormElement/TextAreaShow';
import { isConditionalPass } from '@mpc/common/src/components/AIAcceptance/constants';
import MonitoringLinkAlert from '@mpc/common/src/features/MPCDemand/MonitoringLinkAlert';

export default class Making extends React.Component<MakingProps> {
  public static contextTypes = {
    menuKey: PropTypes.string,
    detail: PropTypes.any,

    loadDetail: PropTypes.func,
    projectMove: PropTypes.func,
  };

  handleSubmitBody = (submitBody: any) => {
    if (hasGrayConfigWithoutGroup(['external.demand_flow.making'])) {
      const { id, making } = submitBody;
      const {
        is_pass = false,
        settle_report_attachs_blob_ids = [],
        demand_advertising_attributes = {},
        ...other
      } = making || {};

      return {
        id,
        state: 'making',
        pass: is_pass,
        form: {
          id,
          final_settle_price: _.get(demand_advertising_attributes, 'final_settle_price'),
          final_settle_currency: _.get(demand_advertising_attributes, 'final_settle_currency'),
          settle_report_attachs_blob_keys: (settle_report_attachs_blob_ids || []).map(
            (i: any) => i?.blob_key || i?.blob?.key,
          ),
          ...other,
        },
      };
    }

    return submitBody;
  };

  render() {
    const { detail, menuKey, loadDetail, projectMove } = this.context;
    const { demand_advertising = {} } = detail;
    const isAdsXiaohao = demand_advertising.ad_settle_way === QuotationsType.XIAOHAO;

    const aiReviewResultFileCount =
      detail?.demand_aireview_result?.items?.reduce((acc: any, item: any) => {
        return acc + (item.groups?.length || 0);
      }, 0) || 0;

    const topSlot = (
      <>
        {detail?.has_monitor_links && (
          <div className="mb-5">
            <MonitoringLinkAlert detail={detail} />
          </div>
        )}
        {detail?.return_flag && (
          <Alert
            message="提交结案退回"
            description={`退回原因：${detail?.return_reason || '--'}`}
            type="warning"
            showIcon
            style={{ margin: `0 0 20px` }}
          />
        )}
        {detail?.sub_state?.toUpperCase() === 'REVIEWING' && (
          <Alert
            message={
              <>
                结案内容审核结果：<span className="rock-typography-info">审核中...</span>
              </>
            }
            description={
              <div>
                预计 <span className="rock-typography-info">5</span>{' '}
                分钟完成审核。如文件较大，时间会延长；审核结果若有异常，将发送通知到邮箱，请及时关注。
              </div>
            }
            type="info"
            showIcon
            icon={<SignetFilled />}
            style={{ margin: `0 0 20px` }}
          />
        )}
        {!!detail?.demand_aireview_result?.review_summary && (
          <Alert
            message={
              <>
                结案内容审核结果：<span className="rock-typography-danger">存在异常</span>
              </>
            }
            description={
              <div>
                <TextAreaShow value={detail?.demand_aireview_result?.review_summary} showLine={10} />
                {[undefined, 'NONE'].includes(detail?.sub_state?.toUpperCase())
                  ? '请修改后重新提交。'
                  : `请点击「退回修改」修改后重新提交；${
                      isConditionalPass(detail?.demand_aireview_result?.ai_accept_info?.acceptance_conclusion)
                        ? '若认为审核结果有误，可点击「确认无问题，不修改」。'
                        : ''
                    }`}
              </div>
            }
            type="error"
            showIcon
            icon={<AlertTriangleFilled />}
            style={{ margin: `0 0 20px` }}
          />
        )}
      </>
    );

    return (
      <>
        {isAdsXiaohao ? (
          <XiaoHao
            {...this.props}
            topSlot={topSlot}
            detail={detail}
            projectMove={projectMove}
            menuKey={menuKey}
            loadDetail={loadDetail}
            handleSubmitBody={this.handleSubmitBody}
          />
        ) : (
          <SmMaking
            {...this.props}
            templateDownloadUrl="outsource/v2/demands/download_case_template"
            handleSubmitBody={this.handleSubmitBody}
            attachementUploadUrl={getAttachementUploadUrl()}
            topSlot={topSlot}
          />
        )}
      </>
    );
  }
}
